import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import SimpleWrapper from "../components/SimpleWrapper";

// You may move this data outside or make props if you wish.
const EMAIL = "support@finelabs.in";
const PHONE = "+91 9138923900";
const PHONE_LINK = "+919138923900";
const ADDRESS = [
	"Fine Labs",
	"96, B-10, Ashok Vihar Phase 3,",
	"Gurugram, Haryana, India - 122001",
];

export default function NewsContactUs() {
	return (
		<SimpleWrapper searchVisible={false} navigation={false}>
			<section className='w-full min-h-screen bg-white flex flex-col items-center px-4 mt-1 py-10'>
				{/* Page heading */}
				<div className='w-full max-w-3xl flex flex-col items-center text-center mb-2'>
					<span className='text-[16px] font-medium '>
						Contact us – Bites App
					</span>
					<h1 className='text-[24px] font-semibold text-[#222] mt-2 mb-2'>
						We’d Love To Hear From You
					</h1>
					<p className='text-[#747681] text-[16px] md:text-base font-normal'>
						We’re Here To Help. For Any Queries, Feedback, Or Support Related To
						The Bites News App, Please Reach Out To Us.
					</p>
				</div>

				{/* Contact methods */}
				<div className='w-full max-w-3xl flex flex-col md:flex-row justify-center items-stretch gap-0 mt-2 mb-2'>
					{/* Email Support */}
					<div className='flex-1 flex flex-col items-center py-6 px-4  rounded-2xl shadow-none mb-3 md:mb-0'>
						<div className='w-14 h-14 rounded-xl flex items-center justify-center bg-[#eaf1fb] mb-3'>
							<FontAwesomeIcon
								icon={faEnvelope}
								className='text-[#0071E3] text-3xl'
							/>
						</div>
						<div className='font-semibold text-[#232425] text-lg mb-1'>
							Email Support
						</div>
						<div className='text-sm text-[#747681] mb-2'>
							Our team can respond in real time
						</div>
						<a
							href={`mailto:${EMAIL}`}
							className='text-[#0071E3] text-base font-medium '>
							{EMAIL}
						</a>
					</div>

					{/* Call Directly */}
					<div className='flex-1 flex flex-col items-center py-6 px-4 rounded-2xl shadow-none'>
						<div className='w-14 h-14 rounded-xl flex items-center justify-center bg-[#eaf1fb] mb-3'>
							<FontAwesomeIcon
								icon={faPhone}
								className='text-[#0071E3] text-3xl'
							/>
						</div>
						<div className='font-semibold text-[#232425] text-lg mb-1'>
							Call us directly
						</div>
						<div className='text-sm text-[#747681] mb-2'>
							Available during business hours
						</div>
						<a
							href={`tel:${PHONE_LINK}`}
							className='text-[#0071E3] text-base font-medium '>
							{PHONE}
						</a>
					</div>
				</div>

				{/* Postal Address (card, right-aligned on desktop, full width on mobile) */}
				<div className='w-full flex justify-center item-center mt-4'>
					<div className='border-2 border-[#72A9F9] rounded-2xl px-6 py-4 bg-white max-w-[355px] w-full mx-auto md:mx-0'>
						<div className='font-semibold text-[#232425] mb-2'>
							Postal Address
						</div>
						{ADDRESS.map((line, idx) => (
							<div key={idx} className='text-[#22282F] text-[16px] font-normal'>
								{line}
							</div>
						))}
					</div>
				</div>

				{/* Footer tagline */}
				<div className='w-full max-w-3xl flex justify-center mt-10 text-center'>
					<p className='text-[#57636C] text-[20px] md:text-base'>
						Bites Is A News App By Fine Labs. Thank You For Using Bites.
					</p>
				</div>
			</section>
		</SimpleWrapper>
	);
}
